module.exports = __webpack_public_path__ + "static/media/MHVA_Bylaws.610a7bda.pdf";